import { Col } from "react-bootstrap";
import { useAppSelector } from "../../services/hooks";
import { useTranslation } from "react-i18next";

export default function ProductDescription() {
    const { t } = useTranslation('productPage')
    const description = useAppSelector((state) => state.product.data.description)
    return (<>
        {description &&
            <Col xs={12}>
                <h2 className="p-2 mx-0 mb-4 border-4 border-bottom border-secondary border-opacity-25">{t('description')}</h2>
                {description}
            </Col>
        }
    </>)
}